import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { redMui } from "@ryde/theme";

export const GenericUploadFileWrapper = styled.header.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "generic-upload-file-wrapper",
})`
  margin-top: 15px;
  max-width: 450px;
`;

export const GenericUploadCreateEntitiesSectionStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "generic-upload-create-entities-section",
  },
)`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const GenericUploadProcessErrorListWrapperStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "generic-upload-process-error-list-wrapper",
  },
)`
  .error-entity-data {
    font-size: 12px;
    margin-top: 4px;
  }
`;

export const GenericUploadPhoneConflictsSectionStyled = styled.section.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "generic-upload-phone-conflicts-section",
  },
)`
  .phone-conflicts__hint {
    margin: 0 0 8px;
    font-size: 14px;
  }

  .phone-conflicts__warning {
    margin: 0 0 8px;
    font-size: 14px;
    font-weight: 500;
    color: ${redMui._500};
  }
`;

export const GenericUploadPrepareErrorStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "generic-upload-prepare-error",
  },
)`
  margin-top: 35px;

  .error-text {
    font-size: 14px;
    font-weight: 500;
    color: ${redMui._500};
  }
`;
